/* Gerado por scripts/publicar-tema.mjs a partir de theme/native-tracking.liquid.
   Nao editar aqui: o proximo publicar sobrescreve. Comentarios estao no fonte. */
(function () {
  'use strict';
  var boot = window.__ARD_BOOT || {};
  var CFG = boot.CFG || {};
  var CTX = boot.CTX || {};


  var DAY = 86400000;

  function setCookie(name, value, days) {
    try {
      var d = new Date(Date.now() + days * DAY);
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax' +
        (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }
  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : '';
  }
  function ls(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) { return null; }
  }
  function uuid() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  var qs = new URLSearchParams(location.search);
  function param(n) { return qs.get(n) || ''; }

  var uid = getCookie('_ard_uid') || ls('_ard_uid') || uuid();
  setCookie('_ard_uid', uid, 390); ls('_ard_uid', uid);

  var interno = (function () {
    try {
      var q = new URLSearchParams(location.search).get('ard_interno');
      if (q === '1') { setCookie('_ard_interno', '1', 365); ls('_ard_interno', '1'); }
      if (q === '0') { setCookie('_ard_interno', '', -1); ls('_ard_interno', ''); }
    } catch (e) {}
    return getCookie('_ard_interno') === '1' || ls('_ard_interno') === '1';
  })();

  var now = Date.now();
  var lastSeen = parseInt(ls('_ard_seen') || '0', 10);
  var sessionNumber = parseInt(ls('_ard_snum') || '0', 10);
  var sid = ls('_ard_sid') || '';
  var isNewSession = !sid || (now - lastSeen) > CFG.sessionMinutes * 60000;
  if (isNewSession) {
    sid = uuid();
    sessionNumber += 1;
    ls('_ard_sid', sid);
    ls('_ard_snum', String(sessionNumber));
  }
  ls('_ard_seen', String(now));
  var ultimaAtividade = now;

  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid',
                   'epik', 'sccid', 'li_fat_id', 'twclid', 'irclickid'];
  var clickIds = {};
  try { clickIds = JSON.parse(ls('_ard_clk') || '{}'); } catch (e) {}
  var clickChanged = false;
  CLICK_IDS.forEach(function (k) {
    var v = param(k);
    if (v) { clickIds[k] = v; clickIds[k + '_ts'] = now; clickChanged = true; }
  });
  if (clickChanged) ls('_ard_clk', JSON.stringify(clickIds));

  var fbp = '', fbc = '', ttp = '';
  function guardado(cookie, chave) {
    var v = getCookie(cookie) || ls(chave) || '';
    return v;
  }
  function manter(cookie, chave, valor, dias) {
    if (!valor) return;
    if (getCookie(cookie) !== valor) setCookie(cookie, valor, dias);
    if (ls(chave) !== valor) ls(chave, valor);
  }
  function gravarCookiesDeAnuncio() {
    if (consentReal && !consent.marketing) { fbp = ''; fbc = ''; ttp = ''; return; }
    fbp = guardado('_fbp', '_ard_fbp') || 'fb.1.' + now + '.' + Math.floor(Math.random() * 2147483647);
    manter('_fbp', '_ard_fbp', fbp, 90);
    fbc = guardado('_fbc', '_ard_fbc');
    if (clickIds.fbclid && (!fbc || fbc.indexOf(clickIds.fbclid) === -1)) {
      fbc = 'fb.1.' + (clickIds.fbclid_ts || now) + '.' + clickIds.fbclid;
    }
    manter('_fbc', '_ard_fbc', fbc, 90);
    ttp = guardado('_ttp', '_ard_ttp') || uuid().replace(/-/g, '').toUpperCase();
    manter('_ttp', '_ard_ttp', ttp, 390);
    if (clickIds.ttclid && getCookie('_ard_ttclid') !== clickIds.ttclid) {
      setCookie('_ard_ttclid', clickIds.ttclid, 90);
    }
  }

  function gaClientId() {
    var c = getCookie('_ga');           // GA1.1.1234567890.1710000000
    if (c) { var p = c.split('.'); if (p.length >= 4) return p[2] + '.' + p[3]; }
    var stored = ls('_ard_gacid');
    if (stored) return stored;
    var gen = Math.floor(Math.random() * 2147483647) + '.' + Math.floor(now / 1000);
    ls('_ard_gacid', gen);
    return gen;
  }
  function gaSessionId() {
    var mid = (CFG.pixels.ga4 || '').replace('G-', '');
    if (mid) {
      var c = getCookie('_ga_' + mid);
      if (c) {
        var p = c.split('.');
        if (p.length >= 3) {
          var m = p[2].match(/^s?(\d+)/);
          if (m) return m[1];
        }
      }
    }
    var s = ls('_ard_gasid');
    if (!s || isNewSession) { s = String(Math.floor(now / 1000)); ls('_ard_gasid', s); }
    return s;
  }

  function readTouch() {
    var t = {};
    try {
      var qs = new URLSearchParams(location.search);
      var n = 0;
      qs.forEach(function (v, k) {
        if (n >= 20 || !v) return;                       // teto contra URL inflada
        var lk = String(k).toLowerCase();
        if (lk.indexOf('utm_') === 0) { t[lk.slice(4)] = String(v).slice(0, 200); n++; }
        else if (lk.indexOf('fx_') === 0) { t[lk] = String(v).slice(0, 200); n++; }
      });
    } catch (e) {}
    CLICK_IDS.forEach(function (k) { if (param(k)) t[k] = param(k); });
    if (!Object.keys(t).length && document.referrer) {
      try {
        var rh = new URL(document.referrer).hostname.replace(/^www\./, '');
        var aqui = location.hostname.replace(/^www\./, '');
        if (rh && rh !== aqui && !REFERRERS_NEUTROS.test(rh)) { t.source = rh; t.medium = 'referral'; }
      } catch (e) {}
    }
    return t;
  }
  var REFERRERS_NEUTROS = /(^|\.)(paypal\.com|shop\.app|shopify\.com|myshopify\.com|shopifycdn\.com|stripe\.com|klarna\.com|afterpay\.com|clearpay\.co\.uk|affirm\.com|adyen\.com|mercadopago\.com(\.br)?|pay\.google\.com|checkout\.com)$/i;
  var touch = readTouch();
  var first = {};
  try { first = JSON.parse(ls('_ard_first') || '{}'); } catch (e) {}
  if (!Object.keys(first).length && Object.keys(touch).length) {
    first = touch; first.ts = now; first.landing = location.href;
    ls('_ard_first', JSON.stringify(first));
  }
  var last = Object.keys(touch).length ? touch : {};
  if (Object.keys(last).length) ls('_ard_last', JSON.stringify(last));
  else { try { last = JSON.parse(ls('_ard_last') || '{}'); } catch (e) {} }

  var UTM_VISIVEIS = {
    source: 'utm_source',
    medium: 'utm_medium',
    campaign: 'utm_campaign',
    term: 'utm_term',
    content: 'utm_content'
  };
  function utmVisiveis() {
    var out = {};
    var temToque = !!(last && last.source);
    for (var k in UTM_VISIVEIS) {
      if (last && last[k]) out[UTM_VISIVEIS[k]] = String(last[k]).slice(0, 200);
      else if (temToque) out[UTM_VISIVEIS[k]] = '';
    }
    return out;
  }
  function assinaturaUtm() {
    var u = utmVisiveis(), partes = [];
    for (var k in u) partes.push(k + '=' + u[k]);
    return partes.join('&');
  }

  var landing = ls('_ard_landing');
  if (!landing || isNewSession) { landing = location.href; ls('_ard_landing', landing); }

  var consentReal = CFG.consentimento === 'real';
  var consent = { analytics: true, marketing: true, sale_of_data: true };
  var consentConhecido = !consentReal;
  var consentDesde = Date.now();
  var aoConhecerConsent = [];
  function apiDeConsentimento() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    return api && typeof api.analyticsProcessingAllowed === 'function' ? api : null;
  }
  function recusaNoCookie() {
    var out = {};
    try {
      var bruto = getCookie('_tracking_consent');
      if (!bruto) return out;
      var j = JSON.parse(bruto);
      var cmp = j && j.con && j.con.CMP;
      if (!cmp) return out;
      if (cmp.a === '0') out.analytics = false;
      if (cmp.m === '0') out.marketing = false;
      if (cmp.s === '0') out.sale_of_data = false;
    } catch (e) {}
    return out;
  }
  function readConsent() {
    if (!consentReal) {
      consent.analytics = true;
      consent.marketing = true;
      consent.sale_of_data = true;
      return consent;
    }
    try {
      var api = apiDeConsentimento();
      if (api) {
        consent.analytics = api.analyticsProcessingAllowed() !== false;
        consent.marketing = api.marketingAllowed() !== false;
        consent.sale_of_data = api.saleOfDataAllowed() !== false;
        return consent;
      }
    } catch (e) {}
    var recusa = recusaNoCookie();
    for (var k in recusa) consent[k] = false;
    return consent;
  }
  function consentPronto() {
    if (consentConhecido) return;
    readConsent();
    consentConhecido = true;
    gravarCookiesDeAnuncio();
    applyGtagConsent();
    var pendentes = aoConhecerConsent.splice(0);
    for (var i = 0; i < pendentes.length; i++) { try { pendentes[i](); } catch (e) {} }
    if (typeof queue !== 'undefined' && queue && queue.length) schedule();
  }
  readConsent();
  if (!consentReal) {
    gravarCookiesDeAnuncio();
  } else if (apiDeConsentimento()) {
    consentPronto();
  } else {
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { consentPronto(); });
      }
    } catch (e) {}
    setTimeout(consentPronto, 2000);
  }
  document.addEventListener('visitorConsentCollected', function (ev) {
    readConsent();
    if (consentReal && ev && ev.detail) {
      consent.analytics = ev.detail.analyticsAllowed !== false;
      consent.marketing = ev.detail.marketingAllowed !== false;
      consent.sale_of_data = ev.detail.saleOfDataAllowed !== false;
    }
    if (!consentConhecido) consentPronto();
    gravarCookiesDeAnuncio();
    applyGtagConsent();
    flush();
  });

  function user() {
    var c = CTX.customer || {};
    return {
      uid: uid,
      sid: sid,
      session_number: sessionNumber,
      fbp: fbp, fbc: fbc,
      ttp: ttp, ttclid: clickIds.ttclid || '',
      gclid: clickIds.gclid || '',
      gbraid: clickIds.gbraid || '',
      wbraid: clickIds.wbraid || '',
      msclkid: clickIds.msclkid || '',
      ga_cid: gaClientId(),
      ga_sid: gaSessionId(),
      email: c.email || ls('_ard_email') || '',
      phone: c.phone || ls('_ard_phone') || '',
      first_name: c.first_name || '',
      last_name: c.last_name || '',
      city: c.city || '',
      region: c.region || '',
      zip: c.zip || '',
      country: c.country || '',
      external_id: String(c.customer_id || uid),
      customer_id: String(c.customer_id || ''),
      lang: CTX.shop.language || document.documentElement.lang || '',
      tz: (Intl.DateTimeFormat().resolvedOptions().timeZone) || '',
      ua: navigator.userAgent,
      interno: interno ? '1' : undefined
    };
  }

  function device() {
    return {
      screen: screen.width + 'x' + screen.height,
      viewport: innerWidth + 'x' + innerHeight,
      dpr: devicePixelRatio || 1,
      lang: navigator.language,
      touch: 'ontouchstart' in window
    };
  }

  var queue = [];
  var timer = null;

  function envelope(events) {
    return {
      user: user(),
      device: device(),
      consent: consent,
      attribution: {
        first: first, last: last,
        landing_page: landing,
        referrer: document.referrer,
        session_number: sessionNumber
      },
      navegador: { gtag: gtagEstado },
      events: events
    };
  }

  var GTAG_SONDA = 'https://analytics.google.com/g/collect';
  var gtagEstado = (CFG.pixels && CFG.pixels.ga4) ? 'pendente' : 'sem_ga4';
  var gtagDesde = Date.now();

  function marcarGtag(estado) {
    if (gtagEstado === estado) return;
    gtagEstado = estado;
    if (timer) { clearTimeout(timer); timer = null; }
    if (queue.length) schedule();
  }

  function gtagCarregou() {
    var gtm = window.google_tag_manager;
    if (!gtm || !gtm[CFG.pixels.ga4]) { marcarGtag('bloqueado'); return; }

    var guardado = '';
    try { guardado = sessionStorage.getItem('_ard_gtag_sonda') || ''; } catch (e) {}
    if (guardado) { marcarGtag(guardado); return; }

    var resolvido = false;
    var fimSonda = function (estado, guardar) {
      if (resolvido) return;
      resolvido = true;
      if (guardar) { try { sessionStorage.setItem('_ard_gtag_sonda', estado); } catch (e) {} }
      marcarGtag(estado);
    };
    setTimeout(function () { fimSonda('lento', false); }, 4000);
    try {
      fetch(GTAG_SONDA, { method: 'POST', mode: 'no-cors', credentials: 'omit', cache: 'no-store', body: '' })
        .then(function () { fimSonda('ok', true); }, function () { fimSonda('bloqueado', true); });
    } catch (e) { fimSonda('bloqueado', true); }
  }

  var LOTE_MAX_BYTES = 28000;

  function proximoLote() {
    var lote = [];
    var bytes = 0;
    while (queue.length && lote.length < 20) {
      var tam = JSON.stringify(queue[0]).length;
      if (lote.length && bytes + tam > LOTE_MAX_BYTES) break;
      lote.push(queue.shift());
      bytes += tam;
    }
    return lote;
  }

  function guardarPendente(lote) {
    try {
      var ctxLote = envelope([]);
      var comContexto = lote.map(function (e) {
        return Object.assign({}, e, {
          user: e.user || ctxLote.user,
          consent: e.consent || JSON.parse(JSON.stringify(ctxLote.consent)),
          attribution: e.attribution || ctxLote.attribution,
          navegador: e.navegador || ctxLote.navegador
        });
      });
      var pend = JSON.parse(ls('_ard_pend') || '[]');
      ls('_ard_pend', JSON.stringify(pend.concat(comContexto).slice(-40)));
    } catch (e) {}
  }

  function enviarLote(lote) {
    try {
      fetch(CFG.endpoint + '/collect', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(envelope(lote)),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors'
      }).then(function (res) {
        if (!res || res.status >= 500) guardarPendente(lote);
      }, function () { guardarPendente(lote); });
    } catch (e) { guardarPendente(lote); }
  }

  function flush(saindo) {
    if (!saindo && !consentConhecido) { schedule(); return; }
    while (queue.length) enviarLote(proximoLote());
  }

  function schedule() {
    if (timer) return;
    var espera = 400;
    if (gtagEstado === 'pendente') espera = Math.max(400, 5000 - (Date.now() - gtagDesde));
    if (!consentConhecido) espera = Math.max(espera, 2050 - (Date.now() - consentDesde));
    timer = setTimeout(function () { timer = null; flush(); }, espera);
  }

  try {
    var limitePend = Math.floor(Date.now() / 1000) - 72 * 3600;
    var pend = JSON.parse(ls('_ard_pend') || '[]');
    if (pend.length) {
      ls('_ard_pend', '[]');
      pend = pend.filter(function (e) { return e && e.event_time >= limitePend; });
      if (pend.length) { queue = queue.concat(pend); schedule(); }
    }
  } catch (e) {}

  var engagementStart = now;
  var engagementMs = 0;
  var engajadoDesde = now;
  var abaVisivel = document.visibilityState !== 'hidden';
  function engajamentoDesdeUltimo() {
    var t = Date.now();
    var d = abaVisivel ? t - (engajadoDesde || t) : 0;
    engajadoDesde = t;
    return Math.max(1, d);
  }

  function track(name, data, opts) {
    opts = opts || {};
    var eid = opts.event_id || (name + '.' + uuid());
    var evt = {
      event: name,
      event_id: eid,
      event_time: Math.floor(Date.now() / 1000),
      source: 'web',
      action_source: 'website',
      shop: CTX.shop.domain,
      url: location.href,
      referrer: document.referrer,
      page: {
        title: document.title,
        template: CTX.page.template,
        path: location.pathname,
        host: location.hostname,
        lang: CTX.shop.language,
        type: CTX.page.template,
        mercado: CTX.shop.country || ''
      },
      ecommerce: (data && data.ecommerce) || {},
      custom: Object.assign(
        { engagement_time_msec: engajamentoDesdeUltimo() },
        (data && data.custom) || {}
      )
    };
    queue.push(evt);
    if (Date.now() - ultimaAtividade > 60000) { ultimaAtividade = Date.now(); ls('_ard_seen', String(ultimaAtividade)); }
    schedule();
    browserPixels(name, evt);
    if (CFG.debug) console.log('[ard-native]', name, evt);
    return eid;
  }

  var META_MAP = {
    page_view: 'PageView', view_item: 'ViewContent', add_to_cart: 'AddToCart',
    begin_checkout: 'InitiateCheckout', search: 'Search', add_to_wishlist: 'AddToWishlist',
    sign_up: 'CompleteRegistration', subscribe: 'Subscribe', lead: 'Lead',
    contact: 'Contact', purchase: 'Purchase'
  };
  var TT_MAP = {
    page_view: 'Pageview', view_item: 'ViewContent', add_to_cart: 'AddToCart',
    begin_checkout: 'InitiateCheckout', search: 'Search', add_to_wishlist: 'AddToWishlist',
    sign_up: 'CompleteRegistration', subscribe: 'Subscribe', lead: 'SubmitForm',
    contact: 'Contact', purchase: 'CompletePayment', select_item: 'ClickButton'
  };

  function idDeCatalogo(item, cfg) {
    if (!cfg || !cfg.formato) return '';
    var p = String(item.product_id || '');
    var v = String(item.variant_id || item.item_id || '');
    var sku = String(item.sku || item.item_sku || '');
    if (cfg.formato === 'shopify_global') return (p && v && cfg.pais) ? 'shopify_' + cfg.pais + '_' + p + '_' + v : '';
    if (cfg.formato === 'product') return p;
    if (cfg.formato === 'sku') return sku;
    if (cfg.formato === 'variant') return v;
    if (cfg.formato === 'product_variant') return (p && v) ? p + '_' + v : '';
    return '';
  }

  function contentIds(items) {
    return (items || []).map(function (i) {
      return idDeCatalogo(i, CFG.catalogo && CFG.catalogo.meta) || String(i.variant_id || i.item_id || i.sku || '');
    });
  }

  var NAO_ESPELHAR = { session_start: true, user_engagement: true };
  var REMARKETING = { view_item: true, view_item_list: true, add_to_cart: true, begin_checkout: true, purchase: true, view_search_results: true };
  var espelhadosNoGtag = {};

  function browserPixels(name, evt) {
    if (!consentConhecido) { aoConhecerConsent.push(function () { browserPixels(name, evt); }); return; }
    var ec = evt.ecommerce || {};
    var items = ec.items || [];

    if (CFG.pixels.meta && window.fbq && META_MAP[name] && consent.marketing) {
      var mp = { currency: ec.currency || CTX.shop.currency, value: ec.value || 0 };
      if (items.length) {
        mp.content_ids = contentIds(items);
        mp.content_type = 'product';
        mp.contents = items.map(function (i) {
          return {
            id: idDeCatalogo(i, CFG.catalogo && CFG.catalogo.meta) || String(i.variant_id || i.item_id),
            quantity: i.quantity, item_price: i.price
          };
        });
        mp.content_name = items[0].item_name;
        mp.num_items = items.reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
      }
      if (ec.transaction_id) mp.order_id = ec.transaction_id;
      if (evt.custom && evt.custom.search_term) mp.search_string = evt.custom.search_term;
      window.fbq('track', META_MAP[name], mp, { eventID: evt.event_id });
    }

    if (CFG.pixels.tiktok && window.ttq && TT_MAP[name] && consent.marketing) {
      var tp = { currency: ec.currency || CTX.shop.currency, value: ec.value || 0 };
      if (items.length) {
        tp.contents = items.map(function (i) {
          return {
            content_id: idDeCatalogo(i, CFG.catalogo && CFG.catalogo.tiktok) || String(i.variant_id || i.item_id),
            content_type: 'product',
            content_name: i.item_name,
            price: i.price,
            quantity: i.quantity
          };
        });
      }
      if (ec.transaction_id) tp.order_id = ec.transaction_id;
      window.ttq.track(TT_MAP[name], tp, { event_id: evt.event_id });
    }
    if ((CFG.pixels.ga4 || CFG.pixels.gads) && window.gtag && consent.analytics &&
        !NAO_ESPELHAR[name] && !espelhadosNoGtag[evt.event_id]) {
      espelhadosNoGtag[evt.event_id] = true;
      var gp = Object.assign({}, evt.custom);
      delete gp.engagement_time_msec;
      if (items.length || ec.value) {
        gp.currency = ec.currency || CTX.shop.currency;
        gp.value = ec.value || 0;
        gp.items = items.map(function (i) {
          var idGoogle = idDeCatalogo(i, CFG.catalogo && CFG.catalogo.google) || i.sku || String(i.variant_id || i.item_id);
          return {
            item_id: idGoogle,
            id: idGoogle,
            item_sku: i.sku || undefined,
            google_business_vertical: 'retail',
            item_name: i.item_name, item_brand: i.item_brand,
            item_category: i.item_category, item_variant: i.item_variant,
            price: i.price, quantity: i.quantity, index: i.index
          };
        });
        if (ec.transaction_id) gp.transaction_id = ec.transaction_id;
      }
      var destinos = [];
      if (CFG.pixels.ga4) destinos.push(CFG.pixels.ga4);
      if (CFG.pixels.gads && !interno && REMARKETING[name]) destinos.push(CFG.pixels.gads);
      if (destinos.length) {
        gp.send_to = destinos.length === 1 ? destinos[0] : destinos;
        window.gtag('event', name, gp);
      }

      var label = CFG.pixels.gads_labels[name];
      if (label && consent.marketing && !interno) {
        window.gtag('event', 'conversion', {
          send_to: label,
          value: ec.value || 0,
          currency: ec.currency || CTX.shop.currency,
          transaction_id: ec.transaction_id || evt.event_id
        });
      }
    }
  }

  function consentGtag() {
    var ads = consent.marketing ? 'granted' : 'denied';
    return {
      ad_storage: ads,
      ad_user_data: ads,
      ad_personalization: ads,
      analytics_storage: consent.analytics ? 'granted' : 'denied'
    };
  }

  var REGIOES_OPT_IN = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT',
    'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'CH'];

  function applyGtagConsent() {
    if (!window.gtag || !(CFG.pixels.ga4 || CFG.pixels.gads)) return;
    window.gtag('consent', 'update', consentGtag());
  }

  function loadPixels() {
    if (CFG.pixels.meta) {
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      var u = user();
      var am = {};
      if (u.email) am.em = u.email;
      if (u.phone) am.ph = u.phone;
      if (u.first_name) am.fn = u.first_name;
      if (u.last_name) am.ln = u.last_name;
      if (u.city) am.ct = u.city;
      if (u.region) am.st = u.region;
      if (u.zip) am.zp = u.zip;
      if (u.country) am.country = u.country;
      am.external_id = u.external_id;
      window.fbq('init', CFG.pixels.meta, am);
    }

    if (CFG.pixels.tiktok) {
      !function (w, d, t) {
        w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
        ttq.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];
        ttq.setAndDefer = function (o, m) { o[m] = function () { o.push([m].concat(Array.prototype.slice.call(arguments, 0))); }; };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function (id) { var o = ttq._i[id] || []; for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(o, ttq.methods[j]); return o; };
        ttq.load = function (id, o) {
          var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
          ttq._i = ttq._i || {}; ttq._i[id] = []; ttq._i[id]._u = url;
          ttq._t = ttq._t || {}; ttq._t[id] = +new Date(); ttq._o = ttq._o || {}; ttq._o[id] = o || {};
          var s = d.createElement('script'); s.type = 'text/javascript'; s.async = !0; s.src = url + '?sdkid=' + id + '&lib=' + t;
          var f = d.getElementsByTagName('script')[0]; f.parentNode.insertBefore(s, f);
        };
        ttq.load(CFG.pixels.tiktok);
      }(window, document, 'ttq');

      var tu = user();
      window.ttq.identify({
        email: tu.email || undefined,
        phone_number: tu.phone || undefined,
        external_id: tu.external_id
      });
    }

    if (CFG.pixels.ga4 || CFG.pixels.gads) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      var padrao = consentGtag();
      padrao.wait_for_update = 500;
      window.gtag('consent', 'default', padrao);
      if (consentReal && !consentConhecido) {
        window.gtag('consent', 'default', {
          ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied',
          wait_for_update: 2000, region: REGIOES_OPT_IN
        });
      }
      window.gtag('js', new Date());

      var g = document.createElement('script');
      g.async = true;
      g.src = 'https://www.googletagmanager.com/gtag/js?id=' + (CFG.pixels.ga4 || CFG.pixels.gads);
      if (CFG.pixels.ga4) {
        g.onerror = function () { marcarGtag('bloqueado'); };
        g.onload = gtagCarregou;
      }
      document.head.appendChild(g);

      var gu = user();
      if (CFG.pixels.ga4) {
        window.gtag('config', CFG.pixels.ga4, {
          send_page_view: false,           // mandamos nos com contexto completo
          user_id: gu.customer_id || undefined,
          user_properties: { session_number: sessionNumber },
          traffic_type: interno ? 'internal' : undefined
        });
      }
      if (CFG.pixels.gads && !interno) {
        window.gtag('config', CFG.pixels.gads, { allow_enhanced_conversions: true });
        if (gu.email || gu.phone) {
          window.gtag('set', 'user_data', {
            email: gu.email || undefined,
            phone_number: gu.phone || undefined,
            address: gu.zip ? {
              first_name: gu.first_name || undefined,
              last_name: gu.last_name || undefined,
              postal_code: gu.zip,
              country: gu.country || undefined
            } : undefined
          });
        }
      }
      applyGtagConsent();
    }
  }

  function pageEvents() {
    track('page_view', {
      custom: {
        page_template: CTX.page.template,
        session_number: sessionNumber,
        is_new_session: isNewSession
      }
    });
    if (isNewSession) track('session_start', {});

    if (CTX.product) {
      var v = (CTX.product.variants || []).filter(function (x) {
        return x.variant_id === CTX.product.selected_variant_id;
      })[0] || CTX.product.variants[0] || {};
      track('view_item', {
        ecommerce: {
          currency: CTX.shop.currency,
          value: v.price || 0,
          items: [{
            product_id: CTX.product.product_id,
            variant_id: v.variant_id,
            sku: v.sku,
            item_name: CTX.product.item_name,
            item_brand: CTX.product.item_brand,
            item_category: CTX.product.item_category,
            item_category2: CTX.product.item_category2,
            item_variant: v.item_variant,
            price: v.price, quantity: 1, index: 0,
            image: CTX.product.image, url: CTX.product.url
          }]
        },
        custom: { availability: CTX.product.available ? 'in_stock' : 'out_of_stock' }
      });
    }

    if (CTX.collection) {
      track('view_item_list', {
        ecommerce: {
          currency: CTX.shop.currency,
          items: CTX.collection.items.map(function (i) {
            return Object.assign({}, i, {
              item_list_id: CTX.collection.item_list_id,
              item_list_name: CTX.collection.item_list_name
            });
          })
        },
        custom: {
          item_list_name: CTX.collection.item_list_name,
          products_count: CTX.collection.products_count
        }
      });
    }

    if (CTX.search && CTX.search.term) {
      track('search', { custom: { search_term: CTX.search.term, results_count: CTX.search.results } });
      track('view_search_results', { custom: { search_term: CTX.search.term } });
    }

    if (CTX.page.template === 'cart' && CTX.cart.count) {
      track('view_cart', { ecommerce: { currency: CTX.cart.currency, value: CTX.cart.value, items: CTX.cart.items } });
    }
  }

  function describe(el) {
    var d = {
      tag: el.tagName.toLowerCase(),
      text: (el.innerText || el.textContent || el.value || '').trim().slice(0, 120),
      id: el.id || '',
      classes: (typeof el.className === 'string' ? el.className : '').slice(0, 160),
      name: el.getAttribute('name') || '',
      aria: el.getAttribute('aria-label') || '',
      href: el.getAttribute('href') || '',
      type: el.getAttribute('type') || '',
      selector: cssPath(el)
    };
    var sec = el.closest('[id^="shopify-section"]');
    if (sec) d.section = sec.id.replace('shopify-section-', '');
    var blk = el.closest('[data-block-id],[data-section-type]');
    if (blk) d.block = blk.getAttribute('data-block-id') || blk.getAttribute('data-section-type') || '';
    return d;
  }

  function cssPath(el) {
    var parts = [];
    var node = el;
    for (var i = 0; node && node.nodeType === 1 && i < 4; i++) {
      var part = node.tagName.toLowerCase();
      if (node.id) { parts.unshift(part + '#' + node.id); break; }
      var cls = (typeof node.className === 'string' ? node.className : '').trim().split(/\s+/)[0];
      if (cls) part += '.' + cls;
      parts.unshift(part);
      node = node.parentElement;
    }
    return parts.join('>').slice(0, 200);
  }

  function isOutbound(href) {
    try { return new URL(href, location.href).hostname !== location.hostname; }
    catch (e) { return false; }
  }

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest(CFG.clickSelectors + ',[data-ard-event]') : null;
    if (!el) return;

    var custom = el.getAttribute('data-ard-event');
    if (custom) {
      var extra = {};
      try { extra = JSON.parse(el.getAttribute('data-ard-params') || '{}'); } catch (e) {}
      track(custom, { custom: Object.assign(describe(el), extra) });
      return;
    }

    var info = describe(el);
    var href = el.getAttribute('href') || '';

    if (href.indexOf('mailto:') === 0) { track('contact', { custom: Object.assign(info, { method: 'email' }) }); return; }
    if (href.indexOf('tel:') === 0) { track('contact', { custom: Object.assign(info, { method: 'phone' }) }); return; }
    if (href && isOutbound(href)) {
      track('outbound_click', { custom: Object.assign(info, { link_url: href, outbound: true }) });
      return;
    }

    var card = el.closest('[data-product-id],.product-card,.card__content,.grid__item');
    if (card && CTX.collection) {
      var pid = card.getAttribute('data-product-id');
      var item = (CTX.collection.items || []).filter(function (i) { return String(i.product_id) === String(pid); })[0];
      if (item) {
        track('select_item', {
          ecommerce: { currency: CTX.shop.currency, value: item.price, items: [item] },
          custom: { item_list_name: CTX.collection.item_list_name, link_url: href }
        });
        return;
      }
    }

    track('click', { custom: Object.assign(info, { link_url: href }) });
  }, true);

  var rage = { el: null, n: 0, t: 0 };
  document.addEventListener('click', function (ev) {
    var t = Date.now();
    if (rage.el === ev.target && t - rage.t < 1000) rage.n++;
    else { rage.el = ev.target; rage.n = 1; }
    rage.t = t;
    if (rage.n === 3) track('rage_click', { custom: describe(ev.target) });
  }, true);

  var formsStarted = new WeakSet();

  document.addEventListener('focusin', function (ev) {
    var form = ev.target.form;
    if (!form || formsStarted.has(form)) return;
    formsStarted.add(form);
    track('form_start', { custom: { form_id: form.id || '', form_action: form.getAttribute('action') || '', form_name: form.getAttribute('name') || '' } });
  }, true);

  function addToCartDoFormulario(form) {
    var campoId = form.querySelector('[name="id"]');
    var campoQtd = form.querySelector('[name="quantity"]');
    addToCartDaVariante(campoId && campoId.value, campoQtd && campoQtd.value);
  }

  function itemDaVariante(idVariante, quantidade) {
    var prod = CTX.product;
    if (!prod || !prod.variants || !prod.variants.length) return null;
    var idSelecionado = String(idVariante || prod.selected_variant_id || '');
    var variante = null;
    for (var i = 0; i < prod.variants.length; i++) {
      if (String(prod.variants[i].variant_id) === idSelecionado) { variante = prod.variants[i]; break; }
    }
    if (!variante) variante = prod.variants[0];
    return {
      product_id: String(prod.product_id || ''),
      variant_id: String(variante.variant_id || ''),
      sku: variante.sku || '',
      item_name: prod.item_name || '',
      item_variant: variante.item_variant || '',
      item_brand: prod.item_brand || '',
      item_category: prod.item_category || '',
      price: Number(variante.price) || 0,
      quantity: Math.max(1, parseInt(quantidade || '1', 10) || 1),
      index: 0
    };
  }

  function addToCartDaVariante(idVariante, quantidade) {
    var prod = CTX.product;
    if (!prod || !prod.variants || !prod.variants.length) return;

    var idSelecionado = String(idVariante || prod.selected_variant_id || '');
    var variante = null;
    for (var i = 0; i < prod.variants.length; i++) {
      if (String(prod.variants[i].variant_id) === idSelecionado) { variante = prod.variants[i]; break; }
    }
    if (!variante) variante = prod.variants[0];

    var qtd = Math.max(1, parseInt(quantidade || '1', 10) || 1);
    var preco = Number(variante.price) || 0;

    track('add_to_cart', {
      ecommerce: {
        currency: CTX.shop.currency,
        value: Math.round(preco * qtd * 100) / 100,
        items: [{
          product_id: String(prod.product_id || ''),
          variant_id: String(variante.variant_id || ''),
          sku: variante.sku || '',
          item_name: prod.item_name || '',
          item_variant: variante.item_variant || '',
          item_brand: prod.item_brand || '',
          item_category: prod.item_category || '',
          price: preco,
          quantity: qtd,
          index: 0
        }]
      }
    });
    flush(true);
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (ev.defaultPrevented) return;
    addToCartDoFormulario(form);
  }, false);

  function injetarAtributosNoForm(form) {
    if (form.getAttribute('data-ard-attrs') === '1') return;
    var vals = {
      _ard_uid: uid,
      _ard_sid: sid,
      _origin: 'fixaro-native',
      _fbp: fbp,
      _fbc: fbc,
      _ttp: ttp,
      _ttclid: clickIds.ttclid || '',
      _gclid: clickIds.gclid || '',
      _gbraid: clickIds.gbraid || '',
      _wbraid: clickIds.wbraid || '',
      _ard_interno: interno ? '1' : ''
    };
    var tok = cartToken();
    if (tok) vals._ard_cart = tok;
    var utm = utmVisiveis();
    for (var uk in utm) vals[uk] = utm[uk];
    for (var k in vals) {
      if (!vals[k]) continue;
      if (form.querySelector('input[name="attributes[' + k + ']"]')) continue;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[' + k + ']';
      input.value = vals[k];
      form.appendChild(input);
    }
    form.setAttribute('data-ard-attrs', '1');
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    var ehCarrinho = action.indexOf('/cart/add') > -1;
    if (ehCarrinho) injetarAtributosNoForm(form);
    var type = form.getAttribute('data-ard-form') || '';
    var campo = function (sel) {
      if (ehCarrinho) return null;
      var lista = form.querySelectorAll(sel);
      for (var i = 0; i < lista.length; i++) if (!/^properties\[/i.test(lista[i].name || '')) return lista[i];
      return null;
    };
    var emailField = campo('input[type="email"],input[name*="email" i]');
    var phoneField = campo('input[type="tel"],input[name*="phone" i]');
    var email = emailField && emailField.value ? emailField.value.trim() : '';
    var phone = phoneField && phoneField.value ? phoneField.value.trim() : '';

    if (email) ls('_ard_email', email);
    if (phone) ls('_ard_phone', phone);

    var info = {
      form_id: form.id || '',
      form_action: action,
      has_email: !!email,
      has_phone: !!phone
    };

    var tipoShopify = ((form.querySelector('[name="form_type"]') || {}).value || '').toLowerCase();
    var name = type;
    if (!name) {
      if (action.indexOf('/contact') > -1 && form.querySelector('[name="contact[body]"],textarea')) name = 'contact';
      else if (action.indexOf('/contact') > -1 || form.querySelector('[name="contact[tags]"]')) name = 'subscribe';
      else if (tipoShopify === 'create_customer') name = 'sign_up';
      else if (tipoShopify === 'customer_login') name = 'login';
      else if (!tipoShopify && /\/account\/?$/.test(action.split('?')[0])) name = 'sign_up';
      else if (action.indexOf('/search') > -1) name = 'search';
      else name = 'form_submit';
    }
    if (name === 'search') return;
    track(name, { custom: info });
    if (name !== 'form_submit') track('form_submit', { custom: info });
  }, true);

  function itemsFromCartResponse(data) {
    var lines = data.items || (data.id ? [data] : []);
    return lines.map(function (l, i) {
      return {
        product_id: String(l.product_id || ''),
        variant_id: String(l.variant_id || l.id || ''),
        sku: l.sku || '',
        item_name: l.product_title || l.title || '',
        item_variant: l.variant_title || '',
        item_brand: l.vendor || '',
        item_category: l.product_type || '',
        price: (l.final_price != null ? l.final_price : l.price || 0) / 100,
        quantity: l.quantity || 1,
        index: i
      };
    });
  }

  function cartEvent(name, items) {
    var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
    track(name, { ecommerce: { currency: CTX.shop.currency, value: Math.round(value * 100) / 100, items: items } });
    persistCartAttributes();
    enviarLink();
    refreshCart().then(function () { persistCartAttributes(); enviarLink(); });
  }

  var carrinhoConhecido = porVariante(CTX.cart.items || []);
  function porVariante(items) {
    var m = {};
    (items || []).forEach(function (i) {
      var k = String(i.variant_id || '');
      if (!k) return;
      if (m[k]) m[k] = Object.assign({}, m[k], { quantity: m[k].quantity + (i.quantity || 0) });
      else m[k] = Object.assign({}, i, { quantity: i.quantity || 0 });
    });
    return m;
  }
  function diferencaDoCarrinho(antes, depois) {
    var somou = [], tirou = [];
    Object.keys(depois).forEach(function (k) {
      var d = depois[k].quantity - (antes[k] ? antes[k].quantity : 0);
      if (d > 0) somou.push(Object.assign({}, depois[k], { quantity: d }));
    });
    Object.keys(antes).forEach(function (k) {
      var d = antes[k].quantity - (depois[k] ? depois[k].quantity : 0);
      if (d > 0) tirou.push(Object.assign({}, antes[k], { quantity: d }));
    });
    return { somou: somou, tirou: tirou };
  }

  function quantidadesDoPedido(corpo) {
    try {
      var q = {};
      var um = function (id, n) { if (id) q[String(id)] = (q[String(id)] || 0) + Math.max(1, parseInt(n || '1', 10) || 1); };
      if (!corpo) return null;
      if (typeof FormData !== 'undefined' && corpo instanceof FormData) { um(corpo.get('id'), corpo.get('quantity')); }
      else if (typeof URLSearchParams !== 'undefined' && corpo instanceof URLSearchParams) { um(corpo.get('id'), corpo.get('quantity')); }
      else if (typeof corpo === 'string') {
        var j = null;
        try { j = JSON.parse(corpo); } catch (e) { j = null; }
        if (j && Array.isArray(j.items)) j.items.forEach(function (it) { um(it && it.id, it && it.quantity); });
        else if (j && j.id) um(j.id, j.quantity);
        else { var p = new URLSearchParams(corpo); um(p.get('id'), p.get('quantity')); }
      }
      return Object.keys(q).length ? q : null;
    } catch (e) { return null; }
  }

  function respostaDoCarrinho(route, d, corpo) {
    if (!d || typeof d !== 'object') return;
    if (route === '/cart/clear') {
      var tudo = diferencaDoCarrinho(carrinhoConhecido, {});
      carrinhoConhecido = {};
      if (tudo.tirou.length) cartEvent('remove_from_cart', tudo.tirou);
      return;
    }
    if (route === '/cart/add') {
      var linhas = itemsFromCartResponse(d);
      if (!linhas.length) return;
      var pedidas = quantidadesDoPedido(corpo);
      var entrou = [];
      linhas.forEach(function (l) {
        var k = String(l.variant_id || '');
        var antes = carrinhoConhecido[k] ? carrinhoConhecido[k].quantity : 0;
        var qtd = (pedidas && pedidas[k]) || (l.quantity - antes);
        entrou.push(Object.assign({}, l, { quantity: qtd > 0 ? qtd : 1 }));
        carrinhoConhecido[k] = Object.assign({}, l);
      });
      cartEvent('add_to_cart', entrou);
      return;
    }
    if (!Array.isArray(d.items)) return;
    var depois = porVariante(itemsFromCartResponse(d));
    var dif = diferencaDoCarrinho(carrinhoConhecido, depois);
    carrinhoConhecido = depois;
    if (dif.somou.length) cartEvent('add_to_cart', dif.somou);
    if (dif.tirou.length) cartEvent('remove_from_cart', dif.tirou);
  }

  var cartRefreshing = null;
  function refreshCart() {
    if (cartRefreshing) return cartRefreshing;
    cartRefreshing = _fetch('/cart.js', { headers: { Accept: 'application/json' }, keepalive: true })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        CTX.cart.token = (c.token || '').split('?')[0] || CTX.cart.token;
        if (CTX.cart.token) setCookie('_ard_ct', CTX.cart.token, 30);
        CTX.cart.value = (c.total_price || 0) / 100;
        CTX.cart.currency = c.currency || CTX.cart.currency;
        CTX.cart.count = c.item_count || 0;
        CTX.cart.items = itemsFromCartResponse(c);
        carrinhoConhecido = porVariante(CTX.cart.items);
        cartRefreshing = null;
        return CTX.cart;
      })
      .catch(function () { cartRefreshing = null; return CTX.cart; });
    return cartRefreshing;
  }

  function cartRoute(url) {
    var caminho = '';
    try { caminho = new URL(String(url || ''), location.href).pathname; } catch (e) { return ''; }
    var m = caminho.match(/\/cart\/(add|change|update|clear)(\.js)?\/?$/);
    return m ? '/cart/' + m[1] : '';
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var route = cartRoute(url);
    var p = _fetch.apply(this, arguments);

    if (/\/\/app\.zedy\.com\.br\/api\/public\/shopify/.test(url)) {
      p.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(function (d) {
          var m = String((d && d.checkout_direct_url) || '').match(/\/checkout\/(Z-[A-Za-z0-9]+)/);
          if (m) enviarLink(m[1]);
        }).catch(function () {});
      }).catch(function () {});
      return p;
    }

    if (!route) return p;
    var corpo = init && init.body;

    p.then(function (res) {
      if (!res || !res.ok) return;
      res.clone().json().then(function (d) { respostaDoCarrinho(route, d, corpo); }).catch(function () {});
    }).catch(function () {});
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__ardUrl = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (corpo) {
    var xhr = this;
    var route = cartRoute(xhr.__ardUrl);
    if (route) {
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        try { respostaDoCarrinho(route, JSON.parse(xhr.responseText), corpo); } catch (e) {}
      });
    }
    return _send.apply(this, arguments);
  };

  function checkoutEventId() {
    return 'begin_checkout.' + (cartToken() || sid);
  }

  function cartToken() {
    var t = CTX.cart.token || getCookie('_ard_ct') || getCookie('cart') || '';
    return String(t).split('?')[0];
  }

  var ultimoEstadoGravado = null;

  function persistCartAttributes() {
    var estado = (cartToken() || '(sem token)') + '|' + assinaturaUtm();
    if (estado === ultimoEstadoGravado) return Promise.resolve();
    ultimoEstadoGravado = estado;

    var attrs = {
      _ard_uid: uid,
      _ard_sid: sid,
      _origin: 'fixaro-native'
    };
    var tok = cartToken();
    if (tok) attrs._ard_cart = tok;
    if (interno) attrs._ard_interno = '1';
    if (fbp) attrs._fbp = fbp;
    if (fbc) attrs._fbc = fbc;
    if (ttp) attrs._ttp = ttp;
    if (clickIds.ttclid) attrs._ttclid = clickIds.ttclid;
    if (clickIds.gclid) attrs._gclid = clickIds.gclid;
    if (clickIds.gbraid) attrs._gbraid = clickIds.gbraid;
    if (clickIds.wbraid) attrs._wbraid = clickIds.wbraid;
    var gc = gaClientId(); if (gc) attrs._ga_cid = gc;
    var gs = gaSessionId(); if (gs) attrs._ga_sid = gs;
    var utm = utmVisiveis();
    for (var uk in utm) attrs[uk] = utm[uk];
    return _fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true
    }).catch(function () {});
  }

  var ultimoLinkado = null;

  function enviarLink(refZedy) {
    var token = cartToken();
    var chave = (token || 'uid:' + uid) + '|' + assinaturaUtm() + (refZedy ? '|' + refZedy : '');
    if (chave === ultimoLinkado) return;
    ultimoLinkado = chave;
    var body = JSON.stringify({
      cart_token: token,
      vitrine_cart_token: token,
      zedy_ref: refZedy || undefined,
      user: user(),
      attribution: { first: first, last: last, referrer: document.referrer, session_number: sessionNumber },
      consent: consent,
      landing_page: landing
    });
    _fetch(CFG.endpoint + '/link', {
      method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body, keepalive: true, credentials: 'omit', mode: 'cors'
    }).catch(function () {});
  }

  function linkNativeCheckout() {
    persistCartAttributes();
    enviarLink();
    return refreshCart().then(function () {
      persistCartAttributes();
      enviarLink();
    });
  }

  var checkoutsEmitidos = {};
  function beginCheckout(extra, itens) {
    linkNativeCheckout();
    var id = checkoutEventId();
    if (checkoutsEmitidos[id]) return;
    checkoutsEmitidos[id] = true;
    var lista = itens || CTX.cart.items;
    var valor = itens
      ? Math.round(itens.reduce(function (s, i) { return s + (Number(i.price) || 0) * (i.quantity || 1); }, 0) * 100) / 100
      : CTX.cart.value;
    track('begin_checkout', {
      ecommerce: { currency: itens ? CTX.shop.currency : CTX.cart.currency, value: valor, items: lista },
      custom: Object.assign({ cart_token: cartToken() || '' }, extra || {})
    }, { event_id: id });
    flush(true);
  }

  function faturaDoCheckout(el) {
    var href = (el && el.getAttribute && el.getAttribute('href')) || '';
    if (href.indexOf('/invoices/') === -1) {
      var a = document.querySelector('a[href*="/invoices/"]');
      href = (a && a.getAttribute('href')) || '';
    }
    var m = href.match(/\/invoices\/([A-Za-z0-9]+)/);
    return m ? m[1] : undefined;
  }

  function checkoutComFatura(extra, el) {
    var fatura = faturaDoCheckout(el);
    if (fatura || !CFG.checkoutDraft) {
      beginCheckout(Object.assign({}, extra, { draft_invoice: fatura }));
      return;
    }
    var feito = false;
    var obs = null;
    var timer = null;
    function enviar() {
      if (feito) return;
      feito = true;
      try { if (obs) obs.disconnect(); } catch (e) {}
      clearTimeout(timer);
      removeEventListener('pagehide', enviar);
      beginCheckout(Object.assign({}, extra, { draft_invoice: faturaDoCheckout(el) }));
    }
    try {
      obs = new MutationObserver(function () { if (faturaDoCheckout(el)) enviar(); });
      obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
    } catch (e) {}
    addEventListener('pagehide', enviar);
    timer = setTimeout(enviar, 5000);
  }

  window.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest
      ? ev.target.closest('[name="checkout"],[href*="/checkout"],[href*="/invoices/"],[data-ard-checkout],.cart__checkout,.cart__checkout-button,.cht_elem_mainBtn,#checkout')
      : null;
    if (el) checkoutComFatura({ trigger: 'click' }, el);
  }, true);

  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.action || form.action.indexOf('/cart') === -1 || !form.querySelector('[name="checkout"]')) return;
    var quem = ev.submitter;
    if (quem && quem.getAttribute && quem.getAttribute('name') !== 'checkout') return;
    checkoutComFatura({ trigger: 'submit' }, quem);
  }, true);

  window.ardLinkCheckout = linkNativeCheckout;

  var marcaLink = 'ard_link:' + uid + '|' + assinaturaUtm();
  var jaLinkou = false;
  try { jaLinkou = sessionStorage.getItem(marcaLink) === '1'; } catch (e) {}
  if (!jaLinkou) {
    enviarLink();
    try { sessionStorage.setItem(marcaLink, '1'); } catch (e) {}
  }

  if (cartToken() && CTX.cart.count) {
    enviarLink();
    var marca = 'ard_attrs:' + cartToken() + '|' + assinaturaUtm();
    var jaGravou = false;
    try { jaGravou = sessionStorage.getItem(marca) === '1'; } catch (e) {}
    if (!jaGravou) {
      persistCartAttributes();
      try { sessionStorage.setItem(marca, '1'); } catch (e) {}
    }
  }

  document.addEventListener('change', function (ev) {
    var el = ev.target;
    if (!el || !el.name) return;
    var name = String(el.name).toLowerCase();
    var isVariant = name === 'id' || name.indexOf('option') === 0 ||
      (el.closest && el.closest('variant-selects,variant-radios,[data-ard-variant]'));
    var isQty = name === 'quantity' || (el.closest && el.closest('quantity-input,[data-ard-qty]'));
    if (!isVariant && !isQty) return;

    var escolhida = el.form && el.form.querySelector ? el.form.querySelector('[name="id"]') : null;
    var itemSel = CTX.product ? itemDaVariante(isVariant && name === 'id' ? el.value : (escolhida && escolhida.value), 1) : null;
    track('select_item', {
      ecommerce: { currency: CTX.shop.currency, items: itemSel ? [itemSel] : [] },
      custom: {
        field: el.name,
        value: String(el.value || '').slice(0, 80),
        kind: isQty ? 'quantity' : 'variant',
        label: (el.getAttribute && el.getAttribute('aria-label')) || ''
      }
    });
  }, true);

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest
      ? ev.target.closest('shopify-accelerated-checkout,[data-shopify="dynamic-checkout"],.shopify-payment-button,.shopify-cleanslate,[data-testid*="Checkout-button"]')
      : null;
    if (!el) return;
    var formProduto = el.closest && el.closest('form[action*="/cart/add"]');
    var itens = null;
    if (formProduto && CTX.product) {
      var idV = formProduto.querySelector('[name="id"]');
      var qtdV = formProduto.querySelector('[name="quantity"]');
      var item = itemDaVariante(idV && idV.value, qtdV && qtdV.value);
      if (item) itens = [item];
    }
    beginCheckout({ trigger: 'express', express_method: describe(ev.target).text || 'wallet' }, itens);
  }, true);

  function nomeSecao(el) {
    var bruto = String(el.id || '').replace(/^shopify-section-/, '');
    var depois = bruto.indexOf('__') > -1 ? bruto.split('__').pop() : bruto;
    depois = depois.replace(/_[A-Za-z0-9]{6}$/, '');           // sufixo aleatorio da Shopify
    if (/^[0-9a-f]{12,}$/i.test(depois) || !depois) {          // id sem significado
      var cls = (typeof el.className === 'string' ? el.className : '')
        .split(' ').filter(function (c) { return c && c.indexOf('shopify-section') !== 0; })[0];
      depois = cls || 'secao';
    }
    return depois.slice(0, 80);
  }

  function observarSecoes() {
    try {
      if (!window.IntersectionObserver) return;
      var vistas = {};
      var obs = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var nome = nomeSecao(entries[i].target);
          if (vistas[nome]) continue;
          vistas[nome] = 1;
          track('section_view', { custom: { section: nome } });
        }
      }, { threshold: 0 });
      var alvos = document.querySelectorAll('.shopify-section,[data-ard-section]');
      for (var j = 0; j < Math.min(alvos.length, 25); j++) obs.observe(alvos[j]);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observarSecoes);
  } else {
    observarSecoes();
  }

  var exitDone = false;
  document.addEventListener('mouseout', function (ev) {
    if (exitDone || ev.clientY > 0 || ev.relatedTarget) return;
    exitDone = true;
    var pct = 0;
    try {
      var h = document.documentElement;
      pct = Math.min(100, Math.round(((window.scrollY + window.innerHeight) / (h.scrollHeight || 1)) * 100));
    } catch (e) {}
    track('exit_intent', { custom: { percent_scrolled: pct, seconds: Math.round((Date.now() - engagementStart) / 1000) } });
  });

  document.addEventListener('invalid', function (ev) {
    var el = ev.target;
    if (!el) return;
    track('form_error', {
      custom: {
        field: el.name || el.id || '',
        message: String(el.validationMessage || '').slice(0, 120),
        form_id: (el.form && (el.form.id || el.form.getAttribute('name'))) || ''
      }
    });
  }, true);

  document.addEventListener('copy', function () {
    try {
      var sel = String((window.getSelection() || '').toString());
      if (sel.length < 3) return;
      var tipo = /@/.test(sel) ? 'email' : /\d[\d\s().-]{5,}/.test(sel) ? 'numero' : 'texto';
      track('content_copy', { custom: { copy_kind: tipo, copy_length: Math.min(sel.length, 9999) } });
    } catch (e) {}
  });

  var marcos = [15, 30, 60, 120, 300];
  var marcoIdx = 0;
  var marcoTimer = setInterval(function () {
    if (marcoIdx >= marcos.length) { clearInterval(marcoTimer); return; }
    var alvo = marcos[marcoIdx];
    if ((Date.now() - engagementStart) / 1000 >= alvo) {
      marcoIdx++;
      track('user_engagement', { custom: { milestone_seconds: alvo } });
    }
  }, 5000);

  var marksHit = {};
  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h <= 0) return;
      var pct = Math.round((scrollY / h) * 100);
      CFG.scrollMarks.forEach(function (m) {
        if (pct >= m && !marksHit[m]) {
          marksHit[m] = true;
          track('scroll', { custom: { percent_scrolled: m } });
        }
      });
    });
  }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      engagementMs += Date.now() - engagementStart;
      track('user_engagement', { custom: { visible_total_msec: engagementMs } });
      abaVisivel = false;
      flush(true);
    } else {
      engagementStart = Date.now();
      engajadoDesde = Date.now();
      abaVisivel = true;
    }
  });
  addEventListener('pagehide', function () { flush(true); });

  document.addEventListener('play', function (ev) {
    var v = ev.target;
    if (!v || v.tagName !== 'VIDEO') return;
    if (v.autoplay || v.muted) return;
    track('video_progress', { custom: { video_title: v.title || v.currentSrc || '', video_percent: 0, video_provider: 'html5' } });
  }, true);

  function caminhoSemVariante() {
    var q = new URLSearchParams(location.search);
    q.delete('variant');
    var resto = q.toString();
    return location.pathname + (resto ? '?' + resto : '');
  }
  var lastPath = caminhoSemVariante();
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () {
      var r = orig.apply(this, arguments);
      setTimeout(function () {
        var p = caminhoSemVariante();
        if (p !== lastPath) { lastPath = p; track('page_view', { custom: { virtual: true } }); }
      }, 0);
      return r;
    };
  });

  var addToCartBuyNowFeito = false;
  window.ard = {
    track: track,
    identify: function (data) {
      if (data.email) ls('_ard_email', data.email);
      if (data.phone) ls('_ard_phone', data.phone);
    },
    flush: flush,
    context: CTX,
    config: CFG,
    user: user,
    addToCart: function (idVariante, quantidade) {
      if (addToCartBuyNowFeito) return false;
      addToCartBuyNowFeito = true;
      addToCartDaVariante(idVariante, quantidade);
      return true;
    },
    handoffAttributes: function (token) {
      var attrs = utmVisiveis();
      attrs._ard_uid = uid;
      attrs._ard_sid = sid;
      attrs._ard_cart = String(token || cartToken()).split('?')[0];
      var identity = user();
      var fields = { fbp: '_fbp', fbc: '_fbc', ttp: '_ttp', ttclid: '_ttclid', gclid: '_gclid', ga_cid: '_ga_cid', ga_sid: '_ga_sid' };
      for (var field in fields) if (identity[field]) attrs[fields[field]] = identity[field];
      if (interno) attrs._ard_interno = '1';
      return attrs;
    }
  };

  loadPixels();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pageEvents);
  } else {
    pageEvents();
  }
})();
